import { Link } from "react-router-dom";
import { NotFoundWrapper } from "./styled";

function PaginaNaoEncontrada() {
  return (
    <NotFoundWrapper>
      <span>404</span>
      <span>Página Não Encontrada</span>
      <span className="redirect">
        Clique aqui <Link to="/">para ir para o Início</Link>
      </span>
    </NotFoundWrapper>
  );
}

export default PaginaNaoEncontrada;
